import { render, staticRenderFns } from "./ImageGallery.vue?vue&type=template&id=d416f9b2&"
import script from "./ImageGallery.vue?vue&type=script&lang=ts&"
export * from "./ImageGallery.vue?vue&type=script&lang=ts&"
import style0 from "./ImageGallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonCircle: require('/tmp/build_4600e676/src/components/button/Circle.vue').default,AdaptiveImageNew: require('/tmp/build_4600e676/src/components/media/AdaptiveImageNew.vue').default,HighResolutionImage: require('/tmp/build_4600e676/src/components/media/HighResolutionImage.vue').default})
